exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00"
};